import { CardProps, Card as _Card } from 'antd';

import { getClassName } from '../_utils';

type Props = Pick<CardProps, 'children' | 'title' | 'className' | 'size'>;

export function Card({ className, ...props }: Props) {
  return <_Card {...props} className={getClassName('card', className)} />;
}
